(function () {
  'use strict';

  // Both offer sections include this file; bind it only once per page.
  if (window.NoroPP) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function scrollBehavior() {
    return reduceMotion.matches ? 'auto' : 'smooth';
  }

  function formatPrice(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function updateHeaderCartCount(count) {
    var shown = count < 100 ? String(count) : '';
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      el.textContent = shown;
      el.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
      bubble.classList.toggle('visually-hidden', count === 0);
    });
    document.querySelectorAll('cart-icon').forEach(function (icon) {
      icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      if (typeof icon.renderCartBubble !== 'function') return;
      try { icon.renderCartBubble(count, false, true); } catch (e) {}
    });
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { data: { itemCount: count, source: 'noro-pp' } }
    }));
  }

  function initBuyBox(root, on) {
    var dataEl = root.querySelector('[data-packs]');
    if (!dataEl) return null;
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return null;
    }
    var packs = data.packs || [];
    var selected = 0;
    packs.forEach(function (pack, index) {
      if (pack.selected) selected = index;
    });
    if (!packs.length) return null;

    function canAdd(pack) {
      if (!pack || data.available === false) return false;
      var qty = Number(pack.qty || 1);
      if (data.tracksInventory && data.inventoryPolicy === 'deny') {
        var stock = Number(data.inventoryQuantity);
        if (Number.isFinite(stock) && stock < qty) return false;
      }
      return true;
    }

    function syncButtons() {
      var ok = canAdd(packs[selected]);
      root.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
        btn.disabled = !ok;
      });
    }

    function selectPack(index) {
      if (index < 0 || index >= packs.length) return;
      selected = index;
      root.querySelectorAll('[data-pick]').forEach(function (btn) {
        var active = Number(btn.getAttribute('data-pick')) === index;
        btn.classList.toggle('is-selected', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      root.querySelectorAll('[data-cta-total]').forEach(function (el) {
        el.textContent = formatPrice(packs[index].total);
      });
      root.querySelectorAll('[data-cta-note]').forEach(function (el) {
        el.textContent = packs[index].note || '';
      });
      root.querySelectorAll('[data-qty-input]').forEach(function (input) {
        input.value = String(packs[index].qty || 1);
      });
      root.querySelectorAll('[data-gift-variant]').forEach(function (input) {
        input.value = /^\d+$/.test(String(packs[index].giftVariant || '')) ? String(packs[index].giftVariant) : '';
      });
      syncButtons();
    }

    function addToCart(button, form) {
      var pack = packs[selected];
      if (!pack || !canAdd(pack)) return;
      // the variant of the form being sent (a page script may switch it, e.g. by colour), else the section's
      form = form || (button && button.closest('form'));
      var input = form && form.querySelector('[data-variant-input]');
      var id = input && /^\d+$/.test(input.value) ? input.value : String(data.variantId || root.getAttribute('data-fallback-variant') || '');
      document.dispatchEvent(new CustomEvent('noro:add-to-cart', {
        detail: { variantId: id, qty: pack.qty, total: pack.total, currency: data.currency }
      }));
      if (!/^\d+$/.test(id)) return;
      var buttons = root.querySelectorAll('[data-add-to-cart]');
      buttons.forEach(function (btn) { btn.disabled = true; });
      var items = [{ id: Number(id), quantity: pack.qty || 1 }];
      if (/^\d+$/.test(String(pack.giftVariant || ''))) items.push({ id: Number(pack.giftVariant), quantity: 1 });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error('cart');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (cartRes) {
          return cartRes.json();
        });
      }).then(function (cart) {
        updateHeaderCartCount(cart && cart.item_count ? cart.item_count : pack.qty || 1);
        // in the theme editor the preview stays on this page
        if (window.Shopify && window.Shopify.designMode) return syncButtons();
        window.location.href = '/cart';
      }).catch(function () {
        syncButtons();
        if (button) button.textContent = 'Pokušaj ponovo';
      });
    }

    root.querySelectorAll('form.noro-pp-form').forEach(function (form) {
      on(form, 'submit', function (ev) {
        ev.preventDefault();
        addToCart(form.querySelector('[data-add-to-cart]'), form);
      });
    });

    selectPack(selected);
    return { select: selectPack, add: addToCart };
  }

  // Gallery: the main image is a row of slides that swipes with a finger (scroll snap).
  // Thumbnails and arrows move the row, and the active thumbnail follows the slide in view.
  // Older markup (one [data-gallery-main] image whose src the thumbnails swap) still works.
  function initGallery(root, on, later) {
    var track = root.querySelector('[data-gallery-track]');
    var main = root.querySelector('[data-gallery-main]');
    if (!track && !main) return null;
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var current = 0;
    thumbs.forEach(function (btn, i) {
      if (btn.classList.contains('is-active')) current = i;
    });

    function markThumb(index) {
      current = index;
      thumbs.forEach(function (btn, i) {
        var active = i === index;
        btn.classList.toggle('is-active', active);
        if (active) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      });
      // the thumbnail row scrolls on phones: keep the active thumbnail in the middle of it
      var thumb = thumbs[index];
      var row = thumb && thumb.parentElement;
      if (row && row.scrollWidth > row.clientWidth) {
        var rowBox = row.getBoundingClientRect();
        var box = thumb.getBoundingClientRect();
        row.scrollTo({ left: row.scrollLeft + box.left - rowBox.left - (row.clientWidth - box.width) / 2, behavior: scrollBehavior() });
      }
    }

    function showSlide(index) {
      var count = track ? track.children.length : thumbs.length;
      if (!count) return;
      index = ((index % count) + count) % count;
      markThumb(index);
      if (track) {
        track.scrollTo({ left: index * track.clientWidth, behavior: scrollBehavior() });
      } else {
        main.src = thumbs[index].getAttribute('data-thumb');
        main.alt = thumbs[index].getAttribute('data-alt') || '';
      }
    }

    if (track) {
      var settle;
      on(track, 'scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current) markThumb(i);
        }, 80);
      }, { passive: true });
      later(function () { clearTimeout(settle); });
      // the other slides load after the page, so a swipe shows the next picture right away
      var loadAll = function () {
        track.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      };
      if (document.readyState === 'complete') loadAll();
      else on(window, 'load', loadAll);
    } else if (thumbs.length > 1) {
      // Older markup has no arrows and no swipe: add both, so the picture can be changed on a phone.
      var box = main.parentElement;
      if (!box.querySelector('[data-gallery-step]')) {
        [['prev', -1, 'Prethodna slika', 'M15 6l-6 6 6 6'], ['next', 1, 'Sledeća slika', 'M9 6l6 6-6 6']].forEach(function (a) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'gallery__nav gallery__nav--' + a[0];
          btn.setAttribute('data-gallery-step', String(a[1]));
          btn.setAttribute('aria-label', a[2]);
          btn.innerHTML = '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="' + a[3] + '"></path></svg>';
          box.appendChild(btn);
          later(function () { btn.remove(); });
        });
      }
      var startX = null;
      var startY = 0;
      on(box, 'touchstart', function (ev) {
        startX = ev.touches[0].clientX;
        startY = ev.touches[0].clientY;
      }, { passive: true });
      on(box, 'touchend', function (ev) {
        if (startX === null) return;
        var dx = ev.changedTouches[0].clientX - startX;
        var dy = ev.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) showSlide(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    return {
      show: showSlide,
      step: function (n) { showSlide(current + n); },
      indexOf: function (thumb) { return thumbs.indexOf(thumb); }
    };
  }

  // Binds one [data-noro-pp] root. Every listener goes through on() so destroy() can remove it
  // when the theme editor replaces the section.
  function init(root) {
    if (root.noroPP) return;
    var cleanups = [];
    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      cleanups.push(function () { target.removeEventListener(type, fn, opts); });
    }
    function later(fn) {
      cleanups.push(fn);
    }

    var buyBox = initBuyBox(root, on);
    var gallery = initGallery(root, on, later);

    on(root, 'click', function (ev) {
      var el = ev.target.closest('[data-pick], [data-add-to-cart], [data-thumb], [data-gallery-step]');
      if (!el || !root.contains(el)) return;
      if (el.hasAttribute('data-pick')) {
        if (!buyBox) return;
        ev.preventDefault();
        buyBox.select(Number(el.getAttribute('data-pick')));
        return;
      }
      if (el.hasAttribute('data-add-to-cart')) {
        if (!buyBox) return;
        ev.preventDefault();
        buyBox.add(el);
        return;
      }
      if (!gallery) return;
      if (el.hasAttribute('data-thumb')) {
        ev.preventDefault();
        gallery.show(gallery.indexOf(el));
        return;
      }
      gallery.step(Number(el.getAttribute('data-gallery-step')));
    });

    var bar = root.querySelector('.sticky-bar');
    var after = root.querySelector('[data-sticky-after]');
    if (bar) {
      var ticking = false;
      var checkBar = function () {
        ticking = false;
        bar.classList.toggle('is-visible', !after || after.getBoundingClientRect().bottom < window.innerHeight);
      };
      var queueCheck = function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(checkBar);
        }
      };
      on(window, 'scroll', queueCheck, { passive: true });
      on(window, 'resize', queueCheck);
      checkBar();
    }

    root.querySelectorAll('[data-scroll-frame]').forEach(function (frame) {
      var sc = frame.querySelector('[data-scroll]');
      var hint = frame.previousElementSibling;
      if (!sc) return;
      if (!hint || !hint.hasAttribute('data-scroll-hint')) hint = null;
      function update() {
        var max = sc.scrollWidth - sc.clientWidth;
        var overflow = max > 2;
        if (hint) {
          hint.hidden = !overflow;
          if (sc.scrollLeft > 20) hint.classList.add('is-used');
        }
        frame.classList.toggle('can-left', overflow && sc.scrollLeft > 2);
        frame.classList.toggle('can-right', overflow && sc.scrollLeft < max - 2);
      }
      on(sc, 'scroll', update, { passive: true });
      on(window, 'resize', update);
      update();
    });

    root.querySelectorAll('[data-street]').forEach(function (sec) {
      var sc = sec.querySelector('[data-street-scroll]');
      var btn = sec.querySelector('[data-street-next]');
      if (!sc) return;
      function maxScroll() { return sc.scrollWidth - sc.clientWidth; }
      function update() { if (btn) btn.hidden = maxScroll() <= 2; }
      if (btn) {
        on(btn, 'click', function () {
          var max = maxScroll();
          var left = sc.scrollLeft >= max - 2 ? 0 : Math.min(sc.scrollLeft + sc.clientWidth * 0.8, max);
          sc.scrollTo({ left: left, behavior: 'smooth' });
        });
      }
      var drag = null;
      var suppressClickUntil = 0;
      on(sc, 'pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        drag = { x: e.clientX, left: sc.scrollLeft, moved: false };
      });
      on(window, 'pointermove', function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (!drag.moved && Math.abs(dx) > 5) {
          drag.moved = true;
          sc.classList.add('is-dragging');
        }
        if (drag.moved) sc.scrollLeft = drag.left - dx;
      });
      on(window, 'pointerup', function () {
        if (!drag) return;
        if (drag.moved) suppressClickUntil = Date.now() + 300;
        drag = null;
        sc.classList.remove('is-dragging');
      });
      on(sc, 'click', function (e) {
        if (Date.now() < suppressClickUntil) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
      on(sc, 'dragstart', function (e) { e.preventDefault(); });
      on(window, 'resize', update);
      update();
    });

    root.querySelectorAll('video[data-autoplay]').forEach(function (video) {
      function play() {
        if (reduceMotion.matches) return;
        var pending = video.play();
        if (pending && pending.catch) pending.catch(function () {});
      }
      if (!('IntersectionObserver' in window)) return play();
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) play();
          else video.pause();
        });
      }, { rootMargin: '200px 0px' });
      observer.observe(video);
      later(function () { observer.disconnect(); });
    });

    root.noroPP = {
      buyBox: buyBox,
      gallery: gallery,
      destroy: function () {
        cleanups.forEach(function (fn) { fn(); });
        cleanups = [];
        delete root.noroPP;
      }
    };
  }

  function destroy(root) {
    if (root.noroPP) root.noroPP.destroy();
  }

  function rootsIn(node) {
    var roots = Array.prototype.slice.call(node.querySelectorAll('[data-noro-pp]'));
    if (node.matches && node.matches('[data-noro-pp]')) roots.unshift(node);
    return roots;
  }

  rootsIn(document).forEach(init);

  // Theme editor: a changed section is re-rendered without a page reload, so the new markup is
  // bound and the old handlers removed. Selecting a block in the sidebar shows it in the preview.
  document.addEventListener('shopify:section:load', function (ev) {
    rootsIn(ev.target).forEach(init);
  });
  document.addEventListener('shopify:section:unload', function (ev) {
    rootsIn(ev.target).forEach(destroy);
  });
  document.addEventListener('shopify:block:select', function (ev) {
    var el = ev.target;
    var root = el.closest && el.closest('[data-noro-pp]');
    var pp = root && root.noroPP;
    if (!pp) return;
    if (pp.gallery && el.hasAttribute('data-thumb')) pp.gallery.show(pp.gallery.indexOf(el));
    else if (pp.buyBox && el.hasAttribute('data-pick')) pp.buyBox.select(Number(el.getAttribute('data-pick')));
    else if (el.tagName === 'DETAILS') el.open = true;
  });

  window.NoroPP = { init: init, destroy: destroy };
})();
